import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useI18n } from 'vue-i18n';
import useAdminSettings from '@/composables/global/use-admin-settings';
import { isValidEmail } from '@/utils/strings';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppHelpLink',
  props: {
    expand: {}
  },
  setup(__props) {
    const {
      adminSettings
    } = useAdminSettings();
    const {
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          AppHelpLink: {
            label: 'Need Help?'
          }
        },
        es: {
          AppHelpLink: {
            label: '¿Necesita Ayuda?'
          }
        }
      }
    });
    return (_ctx, _cache) => {
      var _unref2;
      const _component_ion_label = _resolveComponent("ion-label");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_button = _resolveComponent("ion-button");
      return (_unref2 = _unref(adminSettings)) !== null && _unref2 !== void 0 && _unref2.helpLink ? (_openBlock(), _createBlock(_component_ion_button, {
        key: 0,
        expand: _ctx.expand,
        fill: "clear",
        color: "text",
        href: _unref(isValidEmail)(_unref(adminSettings).helpLink) ? `mailto:${_unref(adminSettings).helpLink}` : _unref(adminSettings).helpLink,
        target: "_blank"
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_label, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('AppHelpLink.label')), 1)]),
          _: 1
        }), _createVNode(_component_ion_icon, {
          name: "open-outline",
          slot: "end"
        })]),
        _: 1
      }, 8, ["expand", "href"])) : _createCommentVNode("", true);
    };
  }
});